export const fixCanonicalUrl = (urlString: string) => {
  const baseUrl = "https://www.reptrak.com";
  const url = new URL(urlString, baseUrl);

  const { pathname } = url;

  return `${baseUrl}${pathname}/`.replace(/\/{2,}$/g, "/");
};
